
<template>
  <template v-if="isPopup">
    <APP_POPUP/>
  </template>
  <template v-else>
    <MILESTONE/>
  </template>
</template>

<script>
import { ref } from "vue";
import routers_milestone from "@/app/milestone/router.js";
import MILESTONE from "@/app/milestone/pages/Milestone.vue";
import APP_POPUP from "@/app/popup/APP_POPUP.vue";

export default {
  name: "APP_WEB",
  components: {
    MILESTONE,
    APP_POPUP
  },

  setup() {
    return {
      isPopup: ref(false),
    };
  },

  beforeCreate() {
    this.isPopup = this.$route.name === "APP_POPUP_MILESTONE";

    routers_milestone.forEach((route) => {
      this.$router.addRoute(route);
    });

    const routeExiste = this.$router.resolve(window.location.pathname)?.name;
    if (routeExiste !== undefined) {
      this.$router.push(window.location.pathname);
    }
  },

  watch: {
    async $route(to, from) {
      this.$root.main_active = true;

      setTimeout(() => {
        if (
          this.$root?.global?.site != undefined &&
          this.$root?.global?.site.sit_id == this.$root?.global?.GarageId &&
          this.$route.name != "Site_DeviceEdit"
        ) {
          this.$router.push({ name: "Home" });
          return;
        }
      }, 1000);
    },

    async "$route.params.sit_id"(newSitId) {
      if (newSitId) {
        this.$root.$root.pageLoad = true;
        if (!this.$root.isPilotLogin) {
          await this.$root.setSite(newSitId);
        }
      } else {
        await this.$root.setSite(undefined);
        this.$root.pageLoad = false;
      }

      if (
        this.$root?.global?.site != undefined &&
        this.$root?.global?.site.sit_id == this.$root?.global?.GarageId &&
        this.$route.name != "Site_DeviceEdit"
      ) {
        this.$router.push({ name: "Home" });
        return;
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setSite(to.params.sit_id);
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.$root.pageLoad = true;
    if (!this.$root.isPilotLogin) {
      this.$root.setSite(to.params.sit_id);
    }
    next();
  },
};
</script>
